"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.Welcome = (_a) => {
    var { userName, children } = _a, otherProps = __rest(_a, ["userName", "children"]);
    return (React.createElement("header", Object.assign({ className: "page-header" }, otherProps),
        React.createElement("span", null, "Welcome,"),
        React.createElement("h2", { className: "page-title" }, userName),
        React.createElement("div", { className: "page-header-slot" }, children)));
};
exports.Welcome.displayName = 'Welcome';



//////////////////
// WEBPACK FOOTER
// ./src/components/Welcome.tsx
// module id = 388
// module chunks = 0